<template>
  <div class="has-bottom">
    <div class="page-main ">
      <page-title />
      <page-card>
        <template slot="header">
          <span>To :</span>
          <!-- <span v-if="+$store.getters.userInfo.type === 0">{{ username }}</span> -->
          <el-select
            v-if="+$store.getters.userInfo.type === 0"
            class="username-select"
            v-model="username"
            placeholder="Please fill in"
            style="width:3.8rem"
          >
            <el-option
              v-for="item in optionsManger"
              :key="item.username"
              :label="item.username"
              :value="item.username"
            ></el-option>
          </el-select>

          <el-select
            v-else
            class="username-select"
            v-model="username"
            filterable
            remote
            reserve-keyword
            placeholder="Please fill in"
            :remote-method="remoteMethod"
            :loading="loadingSelect"
          >
            <el-option
              v-for="item in options"
              :key="item.recipientName"
              :label="item.recipientName"
              :value="item.recipientName"
            >
              <!-- <div
                class="username-text1"
                v-html="getSearchTextRender(item.username)"
              ></div>
              <div
                class="username-text2"
                v-html="getSearchTextRender(item.companyName)"
              ></div> -->
            </el-option>
          </el-select>
        </template>
        <div slot="body">
          <div class="title spaceLeft" style="margin-bottom:0.2rem;">
            <span class="title">Subject :</span>
            <el-input
              v-model="pageData.title"
              placeholder="Please fill in"
              maxlength="200"
            />
          </div>
          <el-input
            v-model="pageData.description"
            placeholder="Please enter a description within 1000 characters"
            type="textarea"
            maxlength="1000"
          />
        </div>
      </page-card>
    </div>
    <page-bottom>
      <template>
        <div class="page-btns">
          <el-button @click="goback">Cancel</el-button>
          <loading-btn @clickHandle="submit" type="primary" label="Submit" />
        </div>
      </template>
    </page-bottom>
  </div>
</template>

<script>
import { send } from "@/api/message.js";
import { producerListForMessage } from "@/api/manager.js";
export default {
  components: {},
  data() {
    return {
      query: undefined,
      username: undefined,
      pageData: {
        title: undefined,
        description: undefined
      },
      loadingSelect: false,
      options: [],
      optionsManger:[
        {username:process.env.VUE_APP_FM_MANAGER},
      ]
    };
  },
  computed: {},
  methods: {
    remoteMethod(query) {
      this.query = query;
      if (query !== "") {
        this.loadingSelect = true;
        producerListForMessage({
          search: query,
          page: 1,
          eachpage: 100
        })
          .then(res => {
            this.loadingSelect = false;
            this.options = res.result.list;
          })
          .catch(err => {
            this.loadingSelect = false;
          });
      } else {
        this.options = [];
      }
    },
    getSearchTextRender(text) {
      let str = "";
      if (text) {
        str = text.replace(
          this.query,
          `<span style="font-weight:bold;color:rgba(0, 0, 0, 0.85);">${
            this.query
          }</span>`
        );
      }
      return str;
    },
    submit(btn) {
      if(!this.username){
        this.$message.error("Please enter a Username")
        btn.closeLoad();
        return;
      }
      if(!this.pageData.title){
        this.$message.error("Please enter a Subject")
        btn.closeLoad();
        return;
      }
      if(!this.pageData.description){
        this.$message.error("Please enter Description")
        btn.closeLoad();
        return;
      }
      const param = {
        title: this.pageData.title,
        description: this.pageData.description,
        recipientName: this.username
      };
      send(param)
        .then(res => {
          btn.closeLoad();
          this.$message.success("Sent message successfully!");
          this.$router.push("/messages/index");
        })
        .catch(err => {
          btn.closeLoad();
        });
    },
    goback() {
      this.$confirm("Would you like to leave ?", "Tips", {
        confirmButtonText: "yes",
        cancelButtonText: "no",
        type: "warning"
      }).then(() => {
        this.$router.push("/messages/index");
      });
    }
  },
  created() {
  }
};
</script>
<style scoped lang="scss">
.page-main {
  ::v-deep .el-textarea__inner {
    background: #fafafa;
    height: calc(100vh - 5rem);
    border: none;
    resize: none;
    padding: 0.24rem 0.32rem;
  }
  ::v-deep .el-input__inner {
    border: none;
  }
}
.title {
  font-size: 0.22rem;
  color: #262626;
  font-weight: bold;
  .el-input {
    flex: 1;
  }
  ::v-deep .el-input__inner {
    border: none;
    font-size: 0.22rem;
    color: #262626;
    font-weight: bold;
  }
}
.username-select {
  width: 6.4rem;
  ::v-deep .el-input__inner {
    font-size: 0.22rem;
    color: #262626;
    font-weight: bold;
  }
}
.el-select-dropdown {
  .el-select-dropdown__item {
    padding: 0.12rem 0.24rem;
    font-size: 0.18rem !important;
    height: auto !important;
    line-height: 0.26rem !important;
  }
  .username-text1 {
    color: rgba(0, 0, 0, 0.65);
  }
  .username-text2 {
    color: rgba(0, 0, 0, 0.25);
  }
  .is-text-active {
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
  }
}
</style>
